import { ReconciliationDayBalance } from "../../../domain/models/accounting/reconciliation-day.model";

type UnknownRecord = Record<string, unknown>;

const isRecord = (value: unknown): value is UnknownRecord =>
  typeof value === "object" && value !== null && !Array.isArray(value);

const isFiniteNumber = (value: unknown): value is number =>
  typeof value === "number" && Number.isFinite(value);

const optionalAmount = (value: unknown): number | null => (isFiniteNumber(value) ? value : null);

export function toApplicableDayId(value: unknown): number | null {
  return isRecord(value) && isFiniteNumber(value["idReconciliationDay"]) ? value["idReconciliationDay"] : null;
}

export function toReconciliationDayBalance(value: unknown): ReconciliationDayBalance | null {
  if (!isRecord(value) || !isFiniteNumber(value["idReconciliationDay"]) || typeof value["businessDate"] !== "string") {
    return null;
  }
  return {
    idReconciliationDay: value["idReconciliationDay"],
    businessDate: value["businessDate"],
    openingBalance: optionalAmount(value["openingBalance"]),
    closingBalance: optionalAmount(value["closingBalance"]),
  };
}
